export enum SubjectRegisterActions {
  Reset = "reset",
  FetchSubjectRegister = "fetchSubjectRegister",
  AddsubjReg = "addsubjReg",
  EditsubjReg = "editsubjReg",
}
